import { render, staticRenderFns } from "./Muskelaufbau.vue?vue&type=template&id=6486aaae&"
import script from "./Muskelaufbau.vue?vue&type=script&lang=js&"
export * from "./Muskelaufbau.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports